import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box, Text } from 'grommet';
import NoAuthLayout, { StyledSubmissionInput, StyledSubmissionField } from '@Components/Layout/NoAuth';
import { useAppTheme } from '@Components/Context';
import { AppButton } from '@Components/Control';
import { sendPasswordResetInstructionsRequest } from '@Actions';
import { paths } from '@Components/configs';

const ForgotPasswordPage = ({ small, sendPasswordResetInstructions }) => {
  const [email, setEmail] = React.useState('');
  const { theme } = useAppTheme();

  const handleSubmit = (e) => {
    e.preventDefault();
    sendPasswordResetInstructions(email, paths.root);
  };

  return (
    <NoAuthLayout
      withBackButton
      seoConfig={null}
      title="Forgot your password?"
      small={small}
    >
      <Box direction="column" width="100%" gap="1rem">
        <Text color={theme.page.primaryText} size="small">
          Please enter your email address to receive password reset instructions, then
          follow the link in the email to reset your password.
        </Text>
        <StyledSubmissionField required name="email" htmlFor="email" type="email">
          <StyledSubmissionInput
            plain
            name="email"
            type="email"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
        </StyledSubmissionField>
        <AppButton
          overrideHover
          level="authSubmit"
          onClick={handleSubmit}
          disabled={!email || (email && !email.includes('@'))}
          bgColor={theme.button.primaryBg}
          color={theme.button.primaryText}
          label="Recover Account"
          alignSelf="center"
        />
      </Box>
    </NoAuthLayout>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    sendPasswordResetInstructions: sendPasswordResetInstructionsRequest,
  }, dispatch);
}

ForgotPasswordPage.propTypes = {
  small: PropTypes.bool.isRequired,
  sendPasswordResetInstructions: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(ForgotPasswordPage);
